import BaseModelAPI from '../BaseModelAPI';

export default class AuditLogin extends BaseModelAPI {
	static entity = 'auditlogin';
	static entityName = 'auditlogin';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.loginTime = '';
			this.userId = '';
			this.user = {};
			this.ipAddress = '';
			this.isLoginSuccess = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}